import { render, staticRenderFns } from "./vHead.vue?vue&type=template&id=0dd8648a&"
import script from "./vHead.vue?vue&type=script&lang=js&"
export * from "./vHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports